import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ATA.FISCAIS.BUSCAR_FISCAIS_LISTAGEM_MODAL](context, objParam) {
		const { data } = await api.ataFiscais.buscarFiscaisListagemModal(objParam)
		return data
	},
	async [actionTypes.ATA.FISCAIS.ADICIONAR_FISCAIS](context, objParam) {
		const { data } = await api.ataFiscais.adicionarFiscais(objParam)
		return data
	},
	async [actionTypes.ATA.FISCAIS.BUSCAR_FISCAIS_ATA](context, objParam) {
		const { data } = await api.ataFiscais.buscarFiscaisAta(objParam)
		return data
	},
	async [actionTypes.ATA.FISCAIS.EXCLUIR_FISCAL_ATA](context, idFiscal) {
		return await api.ataFiscais.excluirFiscalAta(idFiscal)
	},
}
